import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { PersistState } from '~/types/common'

type SettingsState = {
  openSidebar: boolean
  setOpenSidebar: (open: boolean) => void
  resetState: () => void
}

const initialState = {
  openSidebar: true,
}

export const useSettingsStore = create<SettingsState>(
  (persist as unknown as PersistState<SettingsState>)(
    (set) => ({
      ...initialState,
      setOpenSidebar: (open: boolean) => set({ openSidebar: open }),
      resetState: () => set(initialState),
    }),
    {
      name: 'herodx-admin-settings',
    },
  ),
)
